import {createSuggestRepository} from '@yandex-delivery/api/repo/suggest'
import {createTariffsRepository} from '@yandex-delivery/api/repo/tariffs'
import {createSuggestService} from '@yandex-delivery/api/service/suggest'
import {createTariffsService} from '@yandex-delivery/api/service/tariffs'

import {externalFetch, tariffsExternalFetch} from './fetch'

// REPOS
const tariffsRepository = createTariffsRepository({fetch: tariffsExternalFetch})
const suggestRepository = createSuggestRepository({fetch: externalFetch})

// SERVICES
export const tariffsService = createTariffsService(tariffsRepository, {
  hostname: window.location.hostname,
  shouldUseCountryParam: true,
})
export const suggestService = createSuggestService(suggestRepository)
